import { fail, type Result } from '@core/domain/utils/Result.ts';
import { PuntosEntregaApplicationService } from '../../application/PuntosEntregaApplicationService.ts';
import type { PuntosEntregaRepositoryPort } from '../../domain/ports/PuntosEntregaRepositoryPort.ts';

const UNAVAILABLE =
  'El almacenamiento local de puntos de entrega no está disponible en este modo.';

function throwNoPersistence(): never {
  throw new Error(
    'PuntosEntregaApplicationPlaceholder: persistence requires a local SQLite-backed repository.',
  );
}

const emptyRepo: PuntosEntregaRepositoryPort = {
  listPuntosEntrega: () => ({ items: [], total: 0 }),
  getPuntoEntrega: () => null,
  savePuntoEntrega: () => throwNoPersistence(),
  listEntregas: () => [],
  listComunas: () => [],
  listBarriosByComuna: () => [],
  listLugaresByBarrio: () => [],
  listLugaresByComuna: () => [],
  findPuntosEntregaCatalogoById: () => null,
  listTiposDocumento: () => [],
  listTiposBonos: () => [],
  listParentesco: () => [],
  findParticipanteByDocumento: () => null,
  findParticipanteById: () => null,
  findParticipantePuntosEntregaBusquedaPrefillPorDocumento: () => null,
  resolveParticipantePuntosEntregaBusquedaPrefill: () => ({ ok: false, reason: 'not_found' }),
  resolveParticipantePuntosEntregaBusquedaPrefillByParticipanteId: () => ({ ok: false, reason: 'not_found' }),
  listParticipanteBusquedaCandidates: () => [],
  findPuntoEntregaIdForParticipante: () => null,
  findConflictingPuntoEntregaIdForParticipante: () => null,
  resolveBonoIdForPuntoEntregaCaptura: () => null,
  participanteTipoBonoCatalogId: () => null,
  getBonoNombreById: () => null,
  listUploadedOfflinePuntosEntrega: () => [],
  countPendingOfflineExport: () => 0,
  deleteUploadedPuntoEntrega: () => {
    throw new Error(UNAVAILABLE);
  },
};

class PuntosEntregaApplicationPlaceholder extends PuntosEntregaApplicationService {
  constructor() {
    super(emptyRepo);
  }

  override deleteUploadedPuntoEntrega(_id: number): Result<void, string> {
    return fail(UNAVAILABLE);
  }
}

/** In-memory stub when SQLite is not bootstrapped (tests / empty AppContainer). */
export function createPuntosEntregaApplicationPlaceholder(): PuntosEntregaApplicationService {
  return new PuntosEntregaApplicationPlaceholder();
}
